import { css } from 'aphrodite';
import React, { FC } from 'react';
import { style } from './style';

interface Props {
  name?: string;
  icon?: string;
  progress?: number;
  description?: string;
}

export const Achievement: FC<Props> = ({ name, icon, progress = 0, description }) => {
  const styles = style({ showProgress: true, progress: progress, icon: icon });

  return (
    <div className={css(styles.achievement)}>
      <div className={css(styles.resultsContainer)}>
        <span className={css(styles.name)}>{name}</span>
        <div className={css(styles.results)}>
          <img className={css(styles.icon)} src={icon} alt=''></img>
          <div className={css(styles.progressBarContainer)}>
            <div className={css(styles.progressBar)} />
            <div className={css(styles.progressValueContainer)}>
              <span className={css(styles.progressValue)}>{progress}%</span>
            </div>
          </div>
        </div>
      </div>
      <p className={css(styles.description)}>{description}</p>
    </div>
  );
};
